// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc-que[data-v-1d8559f2]{letter-spacing:2px;padding:4px 12px;border:3px solid #fff;border-radius:10px;background-color:#eee;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;min-width:40%;margin:32px auto;font-weight:300;font-size:14pt;text-align:center}", ""]);
// Exports
module.exports = exports;
